import { render, staticRenderFns } from "./HorseNotFound.vue?vue&type=template&id=0a3b76be&"
import script from "./HorseNotFound.vue?vue&type=script&lang=js&"
export * from "./HorseNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports